import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Using the most recent technological stacks, such as Java, Kotlin, and Android Studio, our app developers develop flawless Android apps. The user experience is given top importance in the design of the apps to prevent issues on a range of screens and devices.  We make every effort to go above and beyond your expectations and deliver an app that stays ahead in a competative market.",
  },
  {
    icon: IphoneIcon,
    title: "iPhone App Development",
    description:
      "Our iOS app development services include the complete project, from initial design to smooth execution. Our goal is to work impeccably and deliver unique, intuitive, user-friendly projects that ensure excellent results and meet Apple's high standards. Our desirable toolbox and technologies include Xcode, Objective-C, and Swift for Apple's iOS app product development.",
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description:
      "Using a combination of technical expertise and creativity, our game app development services bring your idea to life. Employing the latest tools like Unity, Unreal Engine, and Cocos2d-x, we create engaging games for a variety of platforms and genres. We deliver a game that may captivate audiences with its captivating gameplay and stunning graphics.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description:
      "Our Flutter app developers use this adaptable framework to build cross-platform mobile applications that operate like native apps. We ensure speedy development cycles and faultless user experiences across iOS and Android devices.By using Flutter's extensive widget library and hot reload capabilities, we provide creative and bespoke solutions customized to your company's needs, allowing you to reach a larger audience.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "With an emphasis on features and speed, we develop advanced mobile applications using React Native that functions flawlessly on both the Android and iOS platforms. We use the component-based architecture of React Native to facilitate quick development cycles and code reuse, leading to economical solutions without compromising on usability or speed.",
  },
  {
    icon: HealthcareIcon,
    title: "Custom App Development",
    description:
      "Our custom app development service is aligned with your specific requirements, giving innovative solutions that fit your business goals. We work together with you to understand your requirements and create a fully customized application that attracts your target audience. We have experience with a variety of technologies and platforms, so your app will stand out with advanced features, intuitive design, and optimal performance.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>Our Mobile App Development Services in Saudi Arabia</h2>
            <p>
              As a premier app development company in Saudi Arabia, we produce
              premium apps that will set a benchmark to run your business
              automatically and provide you with the highest output results.
            </p>
            <p>
              We are always two steps ahead of our competitors as we develop
              apps by considering our users, using the latest technology and
              user-friendly interface. Here are the mobile app development
              services we provide:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h3 className="saudia_h3_head">{item.title}</h3>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
